import { Component, Input, OnInit, forwardRef, Inject } from '@angular/core';
import { TranslateService }        from '@ngx-translate/core';

import { ApiService }      from '../api/api.service';
import { CompanyService }  from '../companies/company.service';
import { ConfirmService }  from '../messages/confirm/confirm.service';
import { MessagesService } from '../messages/messages.service';
import { SessionService }  from '../sessions/session.service';
import { CrudGridService, CrudGridInstance } from '../grids/crud-grid.service';

import { CodeTypeModel }      from '../core/models/code-type';
import { PaymentMethodModel } from './models/payment-method';

@Component({
  selector: 'wor-company-lists-payment-methods',
  template: require('./company-lists.payment-methods.component.html')
})
export class CompanyListsPaymentMethodsComponent implements OnInit {
  @Input() paymentMethods: Array<PaymentMethodModel> = [];

  accounts: Array<CodeTypeModel> = [];
  crudGrid: CrudGridInstance<PaymentMethodModel>;
  collapsed = false;
  loadingAccounts = true;

  constructor (
    @Inject(forwardRef(() => ApiService)) private apiService: ApiService,
    @Inject(forwardRef(() => CompanyService))
    public companyService: CompanyService,
    @Inject(forwardRef(() => ConfirmService)) private confirmService: ConfirmService,
    @Inject(forwardRef(() => CrudGridService)) private crudGridService: CrudGridService,
    @Inject(forwardRef(() => MessagesService)) private messagesService: MessagesService,
    @Inject(forwardRef(() => SessionService))
    public sessionService: SessionService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.crudGrid = this.crudGridService.create<PaymentMethodModel>();
    this.crudGrid.data = this.paymentMethods;
    this.getAccounts();
  }

  getAccounts(): void {
    this.companyService.getPaymentAccounts()
      .then((accounts: Array<CodeTypeModel>) => {
        this.accounts = accounts;
      })
      .finally(() => {
        this.loadingAccounts = false;
      });
  }

  isCashType(method: PaymentMethodModel): boolean {
    return method.payment_method && method.payment_method.toLowerCase() === 'cash';
  }

  saveRow(method: PaymentMethodModel, index: number): void {
    const protocol = method.id ? 'patch' : 'post';
    const url      = method.id ? '/invoice_payment_method' : '/invoice_payment_methods';

    this.apiService[protocol](url, method, 'invoice_payment_method')
      .then((methods: Array<PaymentMethodModel>) => {
        this.crudGrid.data = method.id ? this.crudGrid.data : methods;
        this.crudGrid.toggleEditMode(method, index);
        this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.SAVED.PAYMENT_METHOD'), 'success');
      })
      .catch(err => {
        this.messagesService.error(err);
      });
  }

  removeRow(method: PaymentMethodModel, index: number): void {
    this.confirmService.generic(this.translateService.instant('JS_SPACE.CONFIRM.DELETE_TEMPLATE'))
      .then(() => this.crudGrid.removeRow(method, index, '/invoice_payment_methods', 'id'))
      .then(() => {
        this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.DELETED.PAYMENT_METHOD'), 'success');
        this.crudGrid.data.splice(index, 1);
      });
  }

  toggle(): void {
    this.collapsed = !this.collapsed;
  }
}
